import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { NavLink } from "@/components/NavLink";
import { Ship, Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="min-h-[80vh] flex items-center justify-center px-4 mt-20">
        <div className="text-center max-w-2xl mx-auto animate-fade-in">
          <Ship className="h-24 w-24 text-primary mx-auto mb-6 animate-pulse" />
          <h1 className="text-6xl md:text-8xl font-bold text-foreground mb-4">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-muted-foreground mb-8">
            The page you're looking for seems to have sailed away. Let's get you back on course.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" asChild className="hover-scale">
              <NavLink to="/">
                <Home className="h-5 w-5 mr-2" />
                Back to Home
              </NavLink>
            </Button>
            <Button size="lg" variant="outline" onClick={() => window.history.back()} className="hover-scale">
              <ArrowLeft className="h-5 w-5 mr-2" />
              Go Back
            </Button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
